export const CONSTANT_ID = {
    // Constatnt values, In future if DB id change we can update here ...
    FINANCIAL_PRODUCT: 40,
    FINANCIAL_SERVICE: 58,
    LIFESTYLE_PRODUCT: 51,
    LIFESTYLE_SERVICE: 66
}
